import React, { useState } from 'react';
import { ChevronDown, HelpCircle, CheckCircle, Zap, Users, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      id: 1,
      question: "What is the best Loan Agency in Varanasi for quick approval?",
      answer: "CashPro Financial Services is a trusted Loan Agency in Varanasi known for quick approvals, minimal documentation, and transparent processes. We offer a wide range of loan options including personal, business, and home loans tailored to your needs."
    },
    {
      id: 2,
      question: "How can I apply for a Personal Loan in Varanasi?",
      answer: "You can easily apply for a Personal Loan in Varanasi by contacting CashPro Financial Services. Our team assists you with documentation, eligibility checks, and ensures fast processing so you can get funds without delay. Visit our Personal Loan page or call us directly for immediate assistance."
    },
    {
      id: 3,
      question: "Who is eligible for a Business Loan in Varanasi?",
      answer: "Eligibility for a Business Loan in Varanasi depends on factors like business stability, income, and credit profile. At CashPro Financial Services, we help both small and large businesses secure loans with flexible criteria. Our experts assess your business needs and find the best loan option for you."
    },
    {
      id: 4,
      question: "What documents are required for a Home Loan in Varanasi?",
      answer: "To apply for a Home Loan in Varanasi, you generally need identity proof, address proof, income documents, and property-related papers. Our team guides you step-by-step to make the process smooth and hassle-free. Check our Documents Required page for a detailed checklist."
    },
    {
      id: 5,
      question: "Can I get a Loan Against Property in Varanasi with low interest rates?",
      answer: "Yes, with CashPro Financial Services, you can avail a Loan Against Property in Varanasi at competitive interest rates. The loan amount depends on your property value and repayment capacity. Our experts will help you maximize the loan value at minimal rates."
    },
    {
      id: 6,
      question: "How long does it take to get Business loans in Varanasi approved?",
      answer: "Approval time for Business loans in Varanasi can vary, but with CashPro Financial Services, we aim for quick processing—often within a few working days, depending on documentation and eligibility. Our streamlined process ensures minimal delays."
    },
    {
      id: 7,
      question: "What is the maximum amount I can get for a Personal Loan in Varanasi?",
      answer: "The loan amount for a Personal Loan in Varanasi depends on your income, credit score, and repayment capacity. We help you secure the maximum possible amount with flexible repayment options. Our team will assess your profile and present the best loan amount for your needs."
    },
    {
      id: 8,
      question: "Is it possible to get a Home Loan in Varanasi with a low credit score?",
      answer: "Yes, even with a lower credit score, you may still qualify for a Home Loan in Varanasi. Our experts at CashPro Financial Services work with multiple lenders to find the best possible options for you. We understand that credit scores don't define your financial capability."
    },
    {
      id: 9,
      question: "What are the benefits of choosing CashPro Financial Services?",
      answer: "As a leading Loan Agency in Varanasi, we offer: Fast approvals with minimal documentation, Competitive interest rates across all loan types, Personalized solutions tailored to your needs, Complete assistance throughout the loan process, Expert guidance at every step, and Transparent terms with no hidden charges."
    },
    {
      id: 10,
      question: "How do I choose the right loan option in Varanasi?",
      answer: "Choosing the right loan depends on your financial goals. Whether you need a Personal Loan in Varanasi, Business Loan in Varanasi, or Loan Against Property in Varanasi, our experts guide you to select the best option. Connect with us for a free consultation to understand which loan best suits your requirements."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const services = [
    {
      icon: <Users size={24} />,
      title: "Personal Loan",
      desc: "Quick approval with minimal documentation",
      path: "/personal"
    },
    {
      icon: <FileText size={24} />,
      title: "Home Loan",
      desc: "Affordable financing for your dream home",
      path: "/home-loan"
    },
    {
      icon: <Zap size={24} />,
      title: "Business Loan",
      desc: "Flexible solutions for business growth",
      path: "/business"
    },
    {
      icon: <CheckCircle size={24} />,
      title: "Loan Against Car",
      desc: "Quick cash against your vehicle",
      path: "/loan-againstcar"
    },
    {
      icon: <Zap size={24} />,
      title: "Car Loan Balance Transfer",
      desc: "Reduce EMI and save more",
      path: "/carloan-Balance"
    },
    {
      icon: <Users size={24} />,
      title: "MSME Loan",
      desc: "Support for small & medium enterprises",
      path: "/msme-loan"
    }
  ];

  return (
    <div className="bg-gray-50">
      {/* Hero Image - Matching Other Pages */}
      <div className="mb-6 animate-fade-up">
        <div className="flex justify-center lg:justify-end">
          <img
            src="faq.png"
            alt="FAQ"
            className="max-w-full h-full transition-transform duration-500 hover:scale-105"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header Section */}
        <div className="mb-16 max-w-4xl mx-auto text-center animate-fade-up">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="p-3 bg-yellow-400/20 rounded-full">
              <HelpCircle size={40} className="text-yellow-500" />
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-green-700">Frequently Asked Questions</h1>
          </div>
          <p className="text-gray-700 text-lg leading-relaxed">
            Find quick answers to common questions about loans in Varanasi. Can't find what you need? Our expert team is just a call away!
          </p>
        </div>

        {/* FAQ Content Section - Full Width */}
        <div className="mb-16 w-full">
          <div className="space-y-3">
              {faqs.map((faq, index) => (
                <div
                  key={faq.id}
                  className="group border-l-4 border-transparent hover:border-green-500 bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-300"
                >
                  <button
                    onClick={() => toggleFAQ(index)}
                    className="w-full px-6 sm:px-8 py-5 sm:py-6 bg-white hover:bg-gradient-to-r hover:from-green-50 hover:to-emerald-50 transition-all duration-300 flex items-center justify-between gap-4 focus:outline-none"
                  >
                    <div className="flex items-center gap-4 flex-1">
                      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-100 flex items-center justify-center">
                        <span className="text-green-700 font-bold text-sm">{String(index + 1).padStart(2, '0')}</span>
                      </div>
                      <h3 className="text-left text-base sm:text-lg font-semibold text-gray-900 leading-snug group-hover:text-green-700 transition-colors">
                        {faq.question}
                      </h3>
                    </div>
                    <div
                      className={`flex-shrink-0 w-8 h-8 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center transition-transform duration-300 ${
                        activeIndex === index ? 'rotate-180 scale-110' : ''
                      } shadow-md`}
                    >
                      <ChevronDown
                        size={18}
                        className="text-white transition-transform duration-300"
                      />
                    </div>
                  </button>

                  {activeIndex === index && (
                    <div className="px-6 sm:px-8 py-6 sm:py-7 bg-gradient-to-br from-green-50 via-white to-emerald-50 border-t-2 border-green-200 animate-in fade-in slide-in-from-top-2">
                      <p className="text-gray-700 leading-relaxed text-base font-medium">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
        </div>

        {/* Services Grid */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Our Loan Solutions
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Explore all the loan products we offer designed to meet your financial needs
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {services.map((service, idx) => (
                <Link
                  key={idx}
                  to={service.path}
                  className="group p-6 sm:p-8 bg-gradient-to-br from-white to-gray-50 border-2 border-gray-200 rounded-xl hover:border-green-500 hover:shadow-xl hover:from-green-50 hover:to-emerald-50 transition-all duration-300 cursor-pointer"
                >
                  <div className="p-4 bg-gradient-to-br from-green-400 to-emerald-500 rounded-lg w-fit mb-5 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <div className="text-white">{service.icon}</div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-green-700 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {service.desc}
                  </p>
                  <div className="mt-4 flex items-center gap-2 text-green-700 font-semibold group-hover:translate-x-2 transition-transform">
                    <span>Learn More</span>
                    <ChevronDown size={18} className="rotate-[-90deg]" />
                  </div>
                </Link>
              ))}
            </div>
        </div>

        {/* CTA Section */}
        <section className="bg-gradient-to-r from-green-700 via-green-600 to-emerald-700 rounded-2xl p-8 sm:p-12 text-white text-center mb-16 animate-fade-up">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">Still Have Questions?</h2>
          <p className="text-green-100 text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
            Our expert team is ready to help you find the perfect loan solution. Contact us today for personalized assistance and expert guidance.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/contact"
                  className="px-8 py-4 bg-yellow-400 hover:bg-yellow-300 text-gray-900 font-bold rounded-lg transition-all duration-300 hover:scale-105 shadow-xl text-center hover:shadow-2xl"
                >
                  Contact Us Now
                </Link>
                <a
                  href="tel:+918887141052"
                  className="px-8 py-4 bg-white hover:bg-gray-100 text-green-700 font-bold rounded-lg transition-all duration-300 hover:scale-105 shadow-xl hover:shadow-2xl"
                >
                  📞 Call: +91 88871 41052
                </a>
              </div>
          </section>

        {/* Why Choose Us */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Why Choose CashPro Financial Services?
            </h2>
            <p className="text-gray-600 text-lg">
              Your trusted partner for fast, transparent, and hassle-free loans
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: Zap, title: "Lightning Fast", desc: "Approvals within 2-3 days" },
              { icon: FileText, title: "Minimal Docs", desc: "Easy documentation process" },
              { icon: CheckCircle, title: "Transparent", desc: "No hidden charges ever" },
              { icon: Users, title: "Expert Support", desc: "24/7 dedicated assistance" }
            ].map((item, idx) => (
              <div key={idx} className="p-6 sm:p-8 bg-white rounded-xl border-2 border-gray-200 hover:border-green-500 hover:shadow-lg transition-all duration-300 text-center group">
                <div className="p-4 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full w-fit mx-auto mb-5 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <item.icon size={28} className="text-white" />
                </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-green-700 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
